import { EntityService } from './EntityService';
import { IEntity, IRiskAppEvidence } from '../types';

export class RiskAppEvidenceService extends EntityService<IRiskAppEvidence> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/RiskAppEvidences`);
    }

    public readAllForEvList(
        dataFor: 'Issue' | 'IssueAction' | 'Incident' | 'IncidentAction' | 'Risk' | 'RiskMitigationAction',
        entityID: number
    ): Promise<IEntity[]> {
        const query = `?getGeneralEvidencesForList=${dataFor}&entityID=${entityID}`;
        return this.readAll(query);
    }

}